import { useEffect, useRef, useState } from 'react'
import { useIntl } from 'react-intl'
import useHandleCloseModal from '../../../hooks/HandleCloseModal'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import Swal from 'sweetalert2'
import { KTSVG } from '../../../_metronic/helpers'
import { IComponent } from '../../../interfaces/Analytics/Analytics'
import useAccessToken from '../../../hooks/AccessToken'
import { useAnalyticsStore } from '../../../stores/Analytics/AnalyticStore'
import VirtualizedSelect, { VirtualizedSelectOption } from '../../Select/SelectVirtualized'
import useSWR from 'swr'
import axios from 'axios'
import { User } from '../../../interfaces/User'
import { installDashboard } from '../../../api/Analitik/ComponentCRUD'

interface IProps {
  component: IComponent
}
export default function InstallAnalyticDashboard({ component }: IProps) {
  const intl = useIntl()
  const modalRef = useRef<HTMLDivElement | null>(null)
  const closeModalRef = useRef<HTMLButtonElement>(null)
  const [modalBtnLoading, setModalBtnLoading] = useState(false)
  const { setComponents, components } = useAnalyticsStore()
  const token = useAccessToken()
  const [responsibleOptions, setResponsibleOptions] = useState<VirtualizedSelectOption[]>([])
  const API_URL = process.env.REACT_APP_API_URL
  const fetcher = (url: string) =>
    axios
      .get(url, {
        headers: {
          'X-Auth-token': token,
        },
      })
      .then((res) => res.data.data)
      .catch((error) => {
        throw error.response ? error.response.data : error
      })
  const {
    data: responsibleData = [],
  } = useSWR(`${API_URL}users`, fetcher)
  const formik = useFormik({
    initialValues: {
      dashboardUserAccess: component.dashboardUserAccess,
    },
    validationSchema: Yup.object().shape({}),
    onSubmit: async (values, { setStatus, setSubmitting }) => {
      setSubmitting(true)
      setModalBtnLoading(true)
      try {
        let dashboardUserAccessValue = []
        if(formik.values.dashboardUserAccess.length===1 && formik.values.dashboardUserAccess.includes("ALL")){
          dashboardUserAccessValue= responsibleOptions.filter((opt)=>opt.value!=="ALL").map((opt)=>opt.value)
        }else{
          dashboardUserAccessValue= formik.values.dashboardUserAccess
        }
        const response = await installDashboard({
          inDashboard: dashboardUserAccessValue.length > 0 ? true : false,
          dashboardUserAccess: dashboardUserAccessValue,
          token,
          componentId: component.componentId
        })
        if (response.data.success) {
          Swal.fire({
            icon: 'success',
            heightAuto: false,
            title: intl.formatMessage({ id: 'FORM.VALIDATION.UPDATE_SUCCESS' }),
            timer: 2000,
            timerProgressBar: true,
          })
          setComponents(
            components.map((c) => {
              if (component.componentId === c.componentId) {
                return {
                  ...c,
                  inDashboard: (response.data.data as IComponent).inDashboard,
                  dashboardUserAccess: (response.data.data as IComponent).dashboardUserAccess,
                }
              }
              return c
            })
          )
          closeModalRef.current?.click()
        }
      } catch (error: any) {
        Swal.fire({
          icon: 'error',
          title: error.response.data.message,
          confirmButtonText: 'Ok',
        })
      } finally {
        setSubmitting(false)
        setModalBtnLoading(false)
      }
    },
  })
  const allUser ={
    value: "ALL",
    label: intl.formatMessage({id:"FORM.LABEL.ALL" },{title:intl.formatMessage({id:"FORM.LABEL.USER"})}),
  }
  const { handleCloseModal } = useHandleCloseModal(modalRef, closeModalRef, formik)
  useEffect(() => {
    const responsibleOpt = responsibleData.map((user: User) => {
      return {
        value: user.id,
        label: user.name,
      }
    })
    responsibleOpt.unshift(allUser)
    setResponsibleOptions(responsibleOpt)
  }, [responsibleData])

  useEffect(()=>{
    if(formik.values.dashboardUserAccess.length>=responsibleData.length){
      formik.setFieldValue("dashboardUserAccess", ["ALL"])
    }
  },[formik.values.dashboardUserAccess])
  return (
    <>
      <div
        className={`modal fade`}
        tabIndex={-1}
        id={`install-analytic-dasboard-modal-${component.componentId}`}
        ref={modalRef}
      >
        <div className='modal-dialog modal-dialog-centered'>
          <div className='modal-content'>
            <div className='modal-header'>
              <h5 className='modal-title'>
                {intl.formatMessage({ id: 'FORM.ACTION.INSTALL_ON_DASHBOARD' })}{' '}
                {component.nameComponent}
              </h5>
              <button ref={closeModalRef} data-bs-dismiss='modal' className='d-none'></button>
              <button
                className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                onClick={handleCloseModal}
              >
                <KTSVG
                  path='/media/icons/duotune/arrows/arr061.svg'
                  className='svg-icon svg-icon-2x'
                />
              </button>
            </div>
            {/* form */}
            <form onSubmit={formik.handleSubmit} noValidate>
              <div className='modal-body container'>
                <label className='form-label fs-6 fw-bolder text-dark '>
                  {intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.USER' })}
                </label>
                <VirtualizedSelect
                  onChange={(selectedOptions) => {
                    if(formik.values.dashboardUserAccess.includes("ALL")){
                      formik.setFieldValue(
                        'dashboardUserAccess',
                        selectedOptions
                          ? selectedOptions.map((option: VirtualizedSelectOption) => option.value).filter((value:any)=>value!=="ALL")
                          : []
                      )
                      return
                    }
                    if (selectedOptions.some((opt: any) => opt.value === "ALL")) {
                      formik.setFieldValue('dashboardUserAccess', ["ALL"])
                      return; 
                    }
                      formik.setFieldValue(
                        'dashboardUserAccess',
                        selectedOptions
                          ? selectedOptions.map((option: VirtualizedSelectOption) => option.value)
                          : []
                      )


                  }}
                  closeMenuOnSelect={false}
                  placeholder={`${intl.formatMessage({id:"FORM.LABEL.CHOOSE"})} ${intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.USER' })}  `}
                  options={responsibleOptions}
                  value={responsibleOptions.filter((dashboardUserAccess) =>
                    formik.values.dashboardUserAccess.includes(dashboardUserAccess.value)
                  )}
                  isMulti={true}
                  isSort={false}
                  />
              </div>
              <div className='modal-footer'>
                <button
                  type='button'
                  className='btn btn-light d-none'
                  data-bs-dismiss='modal'
                  ref={closeModalRef}
                >
                  {intl.formatMessage({ id: 'FORM.ACTION.CANCEL' })} tes
                </button>
                <button type='button' className='btn btn-light' onClick={handleCloseModal}>
                  {intl.formatMessage({ id: 'FORM.ACTION.CANCEL' })}
                </button>
                <button
                  type='submit'
                  className={`btn btn-primary me-10 ${modalBtnLoading ? 'disabled' : ''}`}
                  data-kt-indicator={modalBtnLoading ? 'on' : 'off'}
                >
                  <span className='indicator-label'>
                    {intl.formatMessage({ id: 'FORM.ACTION.UPDATE' })}
                  </span>
                  <span className='indicator-progress'>
                    Loading...{' '}
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                </button>
              </div>
            </form>
            {/* form */}
          </div>
        </div>
      </div>
    </>
  )
}
